import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { LoginFailedComponent } from './components/login-failed.component';
import { bpnRedirectionGuard } from './guards/bpn-redirection.guard';
import { ForgotCredentialsComponent } from './components/forgot-credentials/forgot-credentials.component';
import { ResetUnavailableComponent } from './components/reset-unavailable/reset-unavailable.component';
import { ResetLinkExpiredComponent } from './components/reset-link-expired/reset-link-expired.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { canResetPasswordGuard } from './guards/reset-password.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'login-failed',
    component: LoginFailedComponent,
  },
  {
    path: 'forgot-credentials',
    component: ForgotCredentialsComponent,
  },
  {
    path: 'change-password',
    canActivate: [canResetPasswordGuard],
    component: ChangePasswordComponent,
  },
  {
    path: 'reset-unavailable',
    component: ResetUnavailableComponent,
  },
  {
    path: 'reset-link-expired',
    component: ResetLinkExpiredComponent,
  },
  {
    path: 'configure',
    loadChildren: () => import('./configuration/configuration.routes'),
  },
  {
    path: '**',
    canActivate: [bpnRedirectionGuard],
    component: LoginFailedComponent,
  },
];
